export const required = (value) => {
  return value ? undefined : 'Required';
};

export const selectMultiRequired = (value) => {
  const isDefined = (value !== undefined);
  return !isDefined || isDefined && value.length > 0 ? undefined : 'Required';
};

export const email = (value) => {
  return value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ?
  'Enter a valid email address.' : undefined;
};

export const bidAmount = (value) => {
  return value && !/^[0-9]{3,5}$/i.test(value) ?
  'Enter 3 to 5 digits.' : undefined;
};
